import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { SkillResponse } from "src/app/home/scope-sequence/models/skill-response.model";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class SearchApiService {

  public constructor(private http: HttpClient) { }

  public async getSkills(renaissanceSkillIds: string[]): Promise<SkillResponse[]> {
    const payload = {
      renaissanceSkillIds,
      standardSets: [],
      tags: [],
      contentTypes: ['nearpod_free_lessons'],
    };

    const skills = await firstValueFrom(
      this.http.post<SkillResponse[]>(environment.skillsUrl, payload)
    );

    return skills
  }
}
